import oneClickBet from 'app/modules/BetSlip/reducer/oneClickBet';
import betSlipPreferences from 'app/modules/BetSlip/reducer/preferences';
import sidebar from 'app/modules/Layout/Sidebar/reducer';

import stakeTypeGroupIds from '../betting-presentation/grid/reducers';

export default {
  stakeTypeGroupIds,
  sidebar,
  betSlip: {
    oneClickBet,
    preferences: betSlipPreferences,
  },
};
